// Rótulos da campanha de migração do Mercado Pago (zaper-api/MERCADO_PAGO_MIGRACAO_PLAN.md).

const CENARIOS = {
    reconexao_pj: { texto: 'PF → PJ', cor: 'blue darken-1' },
    legado_oauth: { texto: 'Chave de acesso', cor: 'deep-purple darken-1' },
};

const SITUACOES = {
    candidata: { texto: 'Candidata', cor: 'grey darken-1' },
    aguardando: { texto: 'Aguardando lojista', cor: 'blue darken-2' },
    conta_diferente: { texto: 'Conta diferente', cor: 'orange darken-3' },
    sem_referencia: { texto: 'Sem referência', cor: 'red darken-2' },
    concluida: { texto: 'Concluída', cor: 'green darken-2' },
    fora_da_campanha: { texto: 'Conectou fora da onda', cor: 'teal darken-2' },
    pausada: { texto: 'Pausada', cor: 'blue-grey' },
    desfeita: { texto: 'Desfeita', cor: 'brown' },
};

const MOTIVOS_CONTATO = {
    conta_diferente: 'Conta diferente, sem liberação',
    sem_referencia: 'Sem conta de referência',
    nao_viu: 'Liberada há 48h e a tela não apareceu',
    nao_responsavel: '2 ou mais cliques em "Não sou o responsável"',
    adiamentos: 'Usou todos os adiamentos',
    prazo: 'Faltam 2 dias ou menos e não conectou',
    grande: 'Acima de R$ 20 mil/mês, ainda sem conectar',
};

export function cenario(valor) {
    return CENARIOS[valor] || { texto: valor || '—', cor: 'grey' };
}

export function situacao(valor) {
    return SITUACOES[valor] || { texto: valor || '—', cor: 'grey' };
}

export function motivoContato(valor) {
    return MOTIVOS_CONTATO[valor] || valor;
}

/** Centavos → "R$ 1.234,56". */
export function reais(centavos) {
    if (centavos === null || centavos === undefined) {
        return '—';
    }

    const valor = (centavos / 100).toFixed(2).replace('.', ',');

    return `R$ ${valor.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
}

export function contaTexto(conta) {
    if (!conta) {
        return '';
    }

    return [conta.email, conta.documento].filter(Boolean).join(' · ');
}

export const OPCOES_CENARIO = [
    { text: 'Todos', value: null },
    { text: 'PF → PJ', value: 'reconexao_pj' },
    { text: 'Chave de acesso', value: 'legado_oauth' },
];

export const OPCOES_SITUACAO = [
    { text: 'Pendentes (todas menos concluídas)', value: 'pendentes' },
    { text: 'Todas', value: 'todas' },
    { text: 'Candidatas', value: 'candidatas' },
    { text: 'Liberadas', value: 'liberadas' },
    { text: 'Aguardando lojista', value: 'aguardando' },
    { text: 'Conta diferente', value: 'conta_diferente' },
    { text: 'Sem referência', value: 'sem_referencia' },
    { text: 'Concluídas', value: 'concluidas' },
    { text: 'Conectaram fora da onda', value: 'fora_da_campanha' },
    { text: 'Pausadas', value: 'pausadas' },
    { text: 'Desfeitas', value: 'desfeitas' },
];
